import { createApiClient, responseData } from '#lib/api/client.js';

export const getNewsFeed = async (
	fetchFn: typeof globalThis.fetch,
	query: {
		categoryName?: string;
		visibility?: string;
		artistName?: string;
		geotagName?: string;
		isHeni?: 'true' | 'false';
		limit: number;
		offset: number;
	}
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/news-feed', {
			params: { query },
		})
	);
